import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../../utils/api";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";

// Reconnect email with a special offer, from a cooling-client alert (template set in retention settings)
export const ReconnectDialog = ({ alertId, clientName, isEs, onClose, onSent }) => {
  const [f, setF] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!alertId) return setF(null);
    axios.get(`${API}/client-retention/alerts/${alertId}/reconnect-draft`, { withCredentials: true }).then((r) => setF({ ...r.data, to: r.data.to || "" }))
      .catch((e) => { toast.error(e.response?.data?.detail || "Error"); onClose(); });
  }, [alertId]); // eslint-disable-line react-hooks/exhaustive-deps
  const applyOffer = (offer) => setF({ ...f, body: f.offer && f.body.includes(f.offer) ? f.body.replace(f.offer, offer) : f.body, offer });
  const send = async () => {
    setBusy(true);
    try {
      const r = await axios.post(`${API}/client-retention/alerts/${alertId}/reconnect`, { to: f.to, subject: f.subject, body: f.body, offer: f.offer }, { withCredentials: true });
      if (r.data.success) { toast.success(isEs ? `Correo enviado a ${f.to}` : `Sent to ${f.to}`); onSent?.(); onClose(); }
      else toast.error(r.data.message || "Error");
    } catch (e) { toast.error(e.response?.data?.detail || "Error"); }
    setBusy(false);
  };
  return (
    <Dialog open={!!alertId} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl" data-testid="reconnect-dialog">
        <DialogHeader><DialogTitle>{isEs ? "Reconectar con" : "Reconnect with"} {clientName}</DialogTitle>
          <DialogDescription>{isEs ? "Revisa la oferta y el mensaje antes de enviar." : "Review the offer and message before sending."}</DialogDescription></DialogHeader>
        {f && <div className="space-y-3">
          <div className="space-y-1"><Label className="text-xs">{isEs ? "Correo del cliente" : "Client email"}</Label><Input type="email" value={f.to} onChange={(e) => setF({ ...f, to: e.target.value })} data-testid="reconnect-to" /></div>
          <div className="space-y-1"><Label className="text-xs">{isEs ? "Oferta especial" : "Special offer"}</Label><Input value={f.offer} onChange={(e) => applyOffer(e.target.value)} data-testid="reconnect-offer" /></div>
          <div className="space-y-1"><Label className="text-xs">{isEs ? "Asunto" : "Subject"}</Label><Input value={f.subject} onChange={(e) => setF({ ...f, subject: e.target.value })} data-testid="reconnect-subject" /></div>
          <Textarea rows={9} value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} data-testid="reconnect-body" />
          {f.contacts?.length > 0 && <p className="text-xs text-muted-foreground" data-testid="reconnect-history">{isEs ? "Contactos previos" : "Previous contacts"}: {f.contacts.map((c) => `${c.at.slice(0, 10)} ${c.status === "sent" ? "✓" : "✗"}`).join(", ")}</p>}
        </div>}
        <DialogFooter><Button onClick={send} disabled={!f || busy || !f.to.includes("@") || !f.subject.trim() || !f.body.trim()} data-testid="reconnect-send">{isEs ? "Enviar correo" : "Send email"}</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
